import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import Carousel from "../components/Carousel/Carousel";
import HomeFilter from "../components/Filters/HomeFilter";
import ProjectList from "../components/Projects/ProjectList";
import CategoryList from "../components/Categories/CategoryList";
import CharityList from "../components/Charities/CharityList";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { connect } from "react-redux";
import * as actions from "../actions";
import { Helmet } from "react-helmet";

class Home extends Component {
  componentDidMount() {
    this.props.fetchScreenHome();
  }

  render() {
    /**
     * TODO
     * - display a loading icon
     */

    const { home } = this.props.screens;
    const { auth } = this.props;

    if (!home) {
      return (
        <Grid fluid={true}>
          <Row className="show-grid">
            <Col sm={12} md={12}>
              <h4>Loading...</h4>
            </Col>
          </Row>
        </Grid>
      );
    }

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Tikki</title>
          <meta property="og:title" content="Tikki" />
          <meta
            property="og:description"
            content="Tikki is a global, non-profit platform focused on showing you your impact and making sure 100% of your donations goes to the cause."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="http://test.tikki.org" />
          <meta
            property="og:image"
            content="http://test.tikki.org/static/images/Love-Mercy-Sunflower-Lady.jpg"
          />
        </Helmet>
        <Header auth={auth} />
        <Carousel projects={home.carousel} />
        <HomeFilter />
        <div className="home-main">
          <ProjectList
            projects={home.projectsFunding}
            title="Featured Funding Projects"
          />
          {/* <ProjectList
            projects={home.projectsVolunteer}
            title="Featured Volunteer Opportunities"
          /> */}
          <CategoryList categories={home.categories} title="Categories" />
          <CharityList
            charities={home.charities}
            title="Charities and Organisations"
          />
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps({ screens, projects }) {
  return { screens, projects };
}

export default connect(
  mapStateToProps,
  actions
)(Home);



// WEBPACK FOOTER //
// ./src/pages/HomePage.js